'use client'
import * as Direction from '@radix-ui/react-direction'

function DirectionProvider({
  children,
  dir,
}: {
  children: React.ReactNode
  dir: 'rtl' | 'ltr'
}) {
  return <Direction.Provider dir={dir}>{children}</Direction.Provider>
}

export { DirectionProvider }
